/**
 * Session/token lifecycle events emitted while exchanging or refreshing tokens.
 */
export enum TokenExchangeEvents {
  TOKEN_CLEARED = 'token_cleared',
  TOKEN_RECEIVED = 'token_received',
  TOKEN_EXPIRES = 'token_expires',
  TOKEN_EXCHANGED_FAILED = 'token_exchange_error',
  REFRESH_TOKEN_EXPIRES = 'refresh_token_expires',
}
